import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-soc-fullpipe",
  "use": "icon-soc-fullpipe-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-soc-fullpipe\">\r\n  <g fill=\"currentColor\">\r\n    <path d=\"M320 192h384c35 0 64 29 64 64v512c0 35-29 64-64 64H320c-35 0-64-29-64-64V256c0-35 29-64 64-64z\" />\r\n    <path d=\"M384 320h256v64H384zm0 128h256v64H384zm0 128h192v64H384z\" fill=\"#fff\" fill-opacity=\"0.85\" />\r\n  </g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/soc-fullpipe.svg
// module id = MNxa
// module chunks = 488